module.exports = __webpack_public_path__ + "images/assets/2beb8d7d0fc76f69614a130f79802ee7.svg";